'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ONLINE = exports.ONLINE = 'online';
var OFFLINE = exports.OFFLINE = 'offline;';